<template>
  <fragment>
    <div v-if="loading" class="loader-container">
      <le-loader class="spinner" :size="40"></le-loader>
    </div>
    <slot v-else></slot>
  </fragment>
</template>

<script>
  import leLoader from '@vueComponents/le-loader/le-loader.vue';

  import { DATA_STATES } from '@/store/consts';

  export default {
    name: 'loader-wrapper',
    components: {
      leLoader,
    },
    props: {
      state: {
        type: String,
        required: false,
        default: '',
      },
    },
    data() {
      return {};
    },
    computed: {
      loading() {
        return this.state === DATA_STATES.LOADING;
      },
    },
  };
</script>

<style lang="scss">
  .loader-container {
    margin-top: -3rem;
    height: 100%;

    .spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }
</style>
